import React, { Component } from 'react';
import './App.css';
import Resume from './components/resume/resume';


class App extends Component {
  render() {
    return (
      <Resume />
    );
  }
}

export default App;
